import { z } from "zod";
import type { ExperienceLocationType } from "@tabbio/types";

export const EXPERIENCE_LOCATION_TYPES = [
  "Remote",
  "On-site",
  "Hybrid",
] as const satisfies readonly ExperienceLocationType[];

export const experienceLocationTypeSchema = z.enum(EXPERIENCE_LOCATION_TYPES);

export function normalizeExperienceLocationType(
  value: unknown,
): ExperienceLocationType | undefined {
  if (typeof value !== "string") return undefined;

  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, "-");
  if (normalized === "remote") return "Remote";
  if (normalized === "hybrid") return "Hybrid";
  if (normalized === "on-site" || normalized === "onsite") return "On-site";
  return undefined;
}
